module.exports = __webpack_public_path__ + "media/images/banners/banner-2-6ef5ad849c1dcad0cc24eb9418ac5634.png";